module.exports = __webpack_public_path__ + "static/media/logoCircle.af0e0528.svg";